import { string, number } from "yup";
import { validateOnlySpaces } from "@helpers/validation";
import { MAX_NAME_LENGTH } from "./lengthConstants";

const currentYear = new Date().getFullYear();

const maxYear = 2100;

export const CreditCardSchema = (errorT, labelT) =>
  string()
    .matches(/^\d{16}$/, errorT("INVALID", { label: labelT("CARD_NUMBER") }))
    .transform((value) => value.replace(/\s/g, ""))
    .required(errorT("REQUIRED", { label: labelT("CARD_NUMBER") }));

export const ExpirationMonthSchema = (errorT, labelT) =>
  string()
    .matches(
      /^(0[1-9]|1[0-2])$/,
      errorT("INVALID", { label: labelT("EXPIRATION_MONTH") }),
    )
    .required(errorT("REQUIRED", { label: labelT("EXPIRATION_MONTH") }));

export const ExpirationYearSchema = (errorT, labelT) =>
  number()
    .min(currentYear, errorT("EXPIRATION_YEAR_MIN", { currentYear }))
    .max(maxYear, errorT("EXPIRATION_YEAR_MAX", { maxYear }))
    .required(errorT("REQUIRED", { label: labelT("EXPIRATION_YEAR") }));

export const CitySchema = (errorT, labelT) =>
  string()
    .test("NOT_SPACE_ONLY", "SPACES_ONLY_NOT_ALLOWED", validateOnlySpaces)
    .matches(/^[A-Za-z\s]+(?:[.,][A-Za-z\s]+)*$/, errorT("INVALID_CITY"))
    .max(MAX_NAME_LENGTH, "ENTER_UNDER")
    .required(errorT("REQUIRED", { label: labelT("CITY") }));
